export default __webpack_public_path__ + "static/media/buy-a-house.f9eca11a.svg";